import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { OutreachNavigation, OutreachNavigationPage, INaviagtions, mapNavigationsToProps } from '../../../design/organisms/outreach/OutreachNavigation';
import { PageHeader } from '../../organisms/PageHeader';
import { IReportData, IReportDataObject } from '../../../entities/reports/IReportData';
import { IData as OutreachListData } from '../../../store/outreach/outreachList';
import * as UserInfoData from '../../../store/user/userInfo';
import { FetchState } from '../../../entities/FetchState';
import { OutreachList } from '../../organisms/outreach/OutreachList';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
  ); 


// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    list: IReportData<OutreachListData>;
    userInfo: IReportDataObject<UserInfoData.IData>;
 }
const mapStateProps = (state: IApplicationState): IStateProps => ({
    list: state.outreach.outreachList.OutreachList,
    userInfo: state.user.userInfo.UserInfo,
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    naviagations: INaviagtions;
    onLoadList: (medewerkerId) => void;
    onClickDetails: (id: string) => void,
    onClickEdit: (id: string) => void,
 }
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    naviagations: mapNavigationsToProps(dispatch),
    onLoadList: (medewerkerId) => dispatch(RootActionCreators.Outreach.outreachList.FetchData(medewerkerId)),
    onClickDetails: (id: string) => dispatch(RootActionCreators.Navigate.ToOutreachDetail(id)),
    onClickEdit: (id: string) => dispatch(RootActionCreators.Navigate.ToOutreachEdit(id)),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const MyOutreach = (props: AllProps) => {
    const classes = useStyles(useTheme());

    const refresh = () => { 
        if (props.userInfo.state === FetchState.Success) {
            props.onLoadList(props.userInfo.data?.uuid ?? "Invalid");
        }
    }

    // Load data when userInfo state becomes successful
    React.useEffect(() => {
        if (props.userInfo.state === FetchState.Success) {
            refresh();
        }
    }, [props.userInfo.state]);


    return (
        <OutreachNavigation selected={OutreachNavigationPage.MijnOutreach} navigations={props.naviagations}>
            <PageHeader
                title="Outreach"
                subTitle="Mijn Outreach"
                explainText="Hieronder vind je een lijst van al jouw outreach activiteiten die je hebt geregistreerd. Druk op het menu onderaan deze pagina om de volledige lijst te zien, of een nieuwe registratie uit te voeren."
            />

            <OutreachList
                data={props.list.data}
                loading={(props.list.state !== FetchState.Success || props.userInfo.state !== FetchState.Success) && props.list.state !== FetchState.Error && props.userInfo.state !== FetchState.Error}
                hasError={props.list.state === FetchState.Error}
                errorDetails={props.list.errorMessage}
                onClickDetails={props.onClickDetails}
                onClickEdit={props.onClickEdit}
                onRefresh={refresh}
                title="Mijn Outreach Lijst"
            />
        </OutreachNavigation>
    );
};

export default connect<IStateProps, IDispatchProps, {}, IApplicationState>(mapStateProps, mapDispatchProps)(MyOutreach);